import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiDoubleChamili';
const args = {};

export class PetastiDoubleChamili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
